var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 7C2.25 6.58579 2.58579 6.25 3 6.25H21C21.4142 6.25 21.75 6.58579 21.75 7C21.75 7.41421 21.4142 7.75 21 7.75H3C2.58579 7.75 2.25 7.41421 2.25 7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.75C9.66848 3.75 9.35054 3.8817 9.11612 4.11612C8.8817 4.35054 8.75 4.66848 8.75 5V6.25H15.25V5C15.25 4.66848 15.1183 4.35054 14.8839 4.11612C14.6495 3.8817 14.3315 3.75 14 3.75H10ZM16.75 6.25V5C16.75 4.27065 16.4603 3.57118 15.9445 3.05546C15.4288 2.53973 14.7293 2.25 14 2.25H10C9.27065 2.25 8.57118 2.53973 8.05546 3.05546C7.53973 3.57118 7.25 4.27065 7.25 5V6.25H5.25C4.83579 6.25 4.5 6.58579 4.5 7V19C4.5 19.7293 4.78973 20.4288 5.30546 20.9445C5.82118 21.4603 6.52066 21.75 7.25 21.75H16.75C17.4793 21.75 18.1788 21.4603 18.6945 20.9445C19.2103 20.4288 19.5 19.7293 19.5 19V7C19.5 6.58579 19.1642 6.25 18.75 6.25H16.75ZM6 7.75V19C6 19.3315 6.1317 19.6495 6.36612 19.8839C6.60054 20.1183 6.91848 20.25 7.25 20.25H16.75C17.0815 20.25 17.3995 20.1183 17.6339 19.8839C17.8683 19.6495 18 19.3315 18 19V7.75H6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.25C10.4142 10.25 10.75 10.5858 10.75 11V17C10.75 17.4142 10.4142 17.75 10 17.75C9.58579 17.75 9.25 17.4142 9.25 17V11C9.25 10.5858 9.58579 10.25 10 10.25Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10.25C14.4142 10.25 14.75 10.5858 14.75 11V17C14.75 17.4142 14.4142 17.75 14 17.75C13.5858 17.75 13.25 17.4142 13.25 17V11C13.25 10.5858 13.5858 10.25 14 10.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.953d50eb811432b6b0d35ef25b14f9c5.svg";
export { ForwardRef as ReactComponent };